import DOMPurify from 'dompurify';
import {OccasionType} from '../../../gql/pwa/graphql.ts';
import styles from '../occasion_details.module.scss';

const ALLOWED_TAGS = [
    'p',
    'b',
    'i',
    'strong',
    'em',
    'u',
    's',
    'ul',
    'ol',
    'li',
    'br',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'blockquote',
    'hr',
    'span',
];

interface OwnProps {
    occasion: OccasionType;
}
export function Description({occasion}: OwnProps) {
    const sanitized = DOMPurify.sanitize(occasion.description ?? '', {
        ALLOWED_TAGS,
        ALLOWED_ATTR: [],
    });
    return (
        <div>
            <div className={styles.occasion_description} dangerouslySetInnerHTML={{__html: sanitized}} />
        </div>
    );
}
